import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import {
  getData,
  getColumns,
  getIsLoading,
} from '../redux/selectors/RouteModificationTransactionsHistorySelectors';
import ListTable from '../../../../../../common/tables/ListTable';
import TableDefinitions from '../../../../../../common/TableDefinitions';
import { tableLoadData } from '../../../../../../common/tables/actions/ListTableActions';
import { getAssetType } from '../../../../../../common/asset-types/redux/selectors/AssetTypesSelectors';

class RouteModificationTransactionsHistoryContainer extends Component {
  componentDidMount() {
    this.props.tableLoadData({ tableId: 'ROUTE_MODIFICATION_TRANSACTIONS_HISTORY' }, this.props.appContext.appContext, { transactionId: this.props.row.original.id });
  }

  render() {
    return (
      <div>
        <br />
        <br />
        <ListTable
          listId={TableDefinitions.ROUTE_MODIFICATION_TRANSACTIONS_HISTORY.id}
          loading={this.props.isLoading}
          columns={this.props.columns}
          data={this.props.data}
        />
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    data: getData(state),
    columns: getColumns(state),
    appContext: getAssetType(state),
    isLoading: getIsLoading(state),
  };
}

RouteModificationTransactionsHistoryContainer.propTypes = {
  data: PropTypes.arrayOf(PropTypes.object),
  columns: PropTypes.arrayOf(PropTypes.object),
  appContext: PropTypes.objectOf(PropTypes.string),
  tableLoadData: PropTypes.func,
  row: PropTypes.objectOf(PropTypes.shape),
  isLoading: PropTypes.bool,
};

const mapDispatchToProps = (dispatch) => bindActionCreators({
  tableLoadData,
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(RouteModificationTransactionsHistoryContainer);
